import { server, STAFF_FAILED, STAFF_FETCHING, STAFF_SUCCESS } from '../../constants'
import apiEndpoint from '../../api/etrBackend'

const setStateStaffToSuccess = (payload: any) => ({
  type: STAFF_SUCCESS,
  payload: payload
})

const setStateStaffToFetching = () => ({
  type: STAFF_FETCHING
})

const setStateStaffToFailed = () => ({
  type: STAFF_FAILED
})

export const searchSTaff = (name: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(setStateStaffToFetching())

      const result = await apiEndpoint.get(`${server.SEARCH_STAFF}?name=${name}`)
      dispatch(setStateStaffToSuccess(result.data))
    } catch (error) {
      dispatch(setStateStaffToFailed)
    }
  }
}

export const updateStaff = (data: any) => {
  return async (dispatch: any) => {
    await apiEndpoint.patch(`${server.STAFF}`, data)
  }
}

export const newBranchMovement = (payload: any) => {
  return async () => {
    try {
      const { data } = await apiEndpoint.post(`${server.INFO}/staffMovement`, payload)
      return data
    } catch (error) {
      throw error
    }
  }
}

export const getStaffWithActiveBranch = () => {
  return async () => {
    try {
      const { data } = await apiEndpoint.get(`${server.INFO}/getStaffWithActiveBranch`)
      return data
    } catch (error) {
      throw error
    }
  }
}

export const getBranchMovementsHistory = (query?: any) => {
  return async () => {
    try {
      const params = new URLSearchParams(query)
      let queryString = ''
      if (query) {
        queryString = '?' + params.toString()
      }

      const { data } = await apiEndpoint.get(
        `${server.INFO}/getBranchMovementsHistory` + queryString
      )
      return data as any[]
    } catch (error) {
      throw error
    }
  }
}

export const createNewStaff = (body: any) => {
  return async () => {
    try {
      const postData = {
        // createBy,
        ...body
      }
      const { data } = await apiEndpoint.post(server.STAFF, postData)
      return data
    } catch (error) {
      throw error
    }
  }
}
